import React from 'react';
import iconPath from "./../../../helpers/iconHelper";
import FeedImage from "../FeedImage";
import moment from 'moment';
import { Link } from 'react-router-dom';
import {encrypt} from "../../../helpers/CryptoJs";

import PollingOptionDetails from "../../Polling/pollingoptiondetails";

const ShareFeed = (props) => {
    return (
       
    <div className="post_content">
        <div className="post_header post_header_share">
            <div className="list_ico">
                {
                    (props.parent_post.post_user_from_image != '') ? <img className={(props.parent_post.post_user_membership == 'GOLD') ? "gold_user" : ""} src={props.parent_post.post_user_from_image}/> : <img src={iconPath['DEFAULTUSER']}/>
                }
            </div>
            <div className="list_details">
                <Link to={`/user/${encrypt(props.parent_post.post_user_from_id)}`}><h4>{props.parent_post.post_user_from_name}</h4></Link>
                <p>{(moment(props.parent_post.posted_on).format('DD-MM-YYYY'))}</p>
            </div>
        </div>


        { (props.data_type == 'POLL') ? 
            <a href={`/polling/${encrypt(props.parent_post.feed_id)}`} >
               
                     <div className="polling-content">
                    
                            <h5 dangerouslySetInnerHTML={{ __html: ' '+props.parent_post.content+ ' ' }}></h5>
                    
                     </div>

                     <PollingOptionDetails 
                        optionDetails = {props.parent_post.poll_details} 
                        voteStatus    = {props.parent_post.poll_vote_status}
                        data_type     = {props.data_type}
                        urlFeedId     = {props.parent_post.feed_id} 
                        post_id       = {props.parent_post.post_id} 
                    />     
               
            </a>
            :
            <Link to={props.data_type == 'GALLERY IMAGE' ? `/media/${encrypt(props.parent_post.media_details[0].gallery_id)}` : `/post/${encrypt(props.parent_post.feed_id)}`}>
                {
                    ((props.parent_post.media_details).length > 0) ? 
                    <FeedImage 
                        media_details = {props.parent_post.media_details} 
                        dynamic_class = "post_img for_post_share"
                    />
                    : null
                }
                
                
                <div className="post_details">
                    <h5 dangerouslySetInnerHTML={{ __html: ' '+props.parent_post.content+ ' ' }}></h5>
                </div>
            </Link>
        }
    </div>
  );
};

export default ShareFeed;